/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorBinaryLogic extends models.QueryOperatorBinary {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorBinaryLogic");
    }

    getFixupPrototypeFunction() { return QueryOperatorBinaryLogic.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorBinaryLogic>): QueryOperatorBinaryLogic {
        let obj = Object.assign(new QueryOperatorBinaryLogic(), model);
        QueryOperatorBinaryLogic.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorBinaryLogic>): QueryOperatorBinaryLogic {
        if (!model) return null;
        return QueryOperatorBinaryLogic.newInstance(<QueryOperatorBinaryLogic> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorBinaryLogic) {
        if (!obj) return;

        models.QueryOperatorBinaryLogic.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorBinaryLogic): boolean {
        if (models.QueryOperatorBinary.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorBinaryLogic.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of binary operation
     */
    op: models.ResourceQueryCondition;

}
